import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface RemoveLayerConfirmationModalProps {
  layerNameText: string;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

export default function RemoveLayerConfirmationModal({
  layerNameText,
  onRequestClose,
  onRequestSubmit,
}: RemoveLayerConfirmationModalProps): JSX.Element {
  const modalBodyText = `Changes made to this ${layerNameText} will not be saved. Are you sure you want to remove this ${layerNameText} layer?`;
  return (
    <Modal
      buttons={[
        {
          text: 'Yes, remove layer',
          submit: true,
          style: ButtonStyle.PRIMARY,
        },
      ]}
      onRequestSubmit={onRequestSubmit}
      onRequestClose={onRequestClose}
      title={`Remove ${layerNameText} layer?`}
    >
      {modalBodyText}
    </Modal>
  );
}
